import { fromJS } from "immutable";
import { actionTypes } from "../constants/aiChatConstants";

// Initial state for the AI chat
const initialState = fromJS({
  messages: [],
  loading: false,
  error: null,
});

/**
 * Reducer for handling AI chat state
 *
 * @param {Object} state - Current state
 * @param {Object} action - Action to handle
 * @returns {Object} - Updated state
 */
const aiChatReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_AI_CHAT_MESSAGE:
      return state.update("messages", (messages) => messages.push(action.payload));

    case actionTypes.SET_AI_CHAT_LOADING:
      return state.set("loading", action.payload);

    case actionTypes.SET_AI_CHAT_ERROR:
      return state.set("error", action.payload);

    case actionTypes.CLEAR_AI_CHAT_ERROR:
      return state.set("error", null);

    case actionTypes.CLEAR_AI_CHAT_HISTORY:
      // Filter out messages for specific chat ID
      return state.update("messages", (messages) =>
        messages.filter((message) => message.get("chatId") !== action.payload)
      );

    default:
      return state;
  }
};

export default aiChatReducer;